"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tokenizer = exports.tokenize = void 0;
var Settings_1 = require("./Settings");
function tokenize(exp, settings) {
    return new Tokenizer(exp, settings).process();
}
exports.tokenize = tokenize;
var Tokenizer = /** @class */ (function () {
    // tslint:enable:variable-name
    function Tokenizer(exp, settings) {
        if (settings === void 0) { settings = Settings_1.Settings.default; }
        this.exp = exp;
        this.settings = settings;
        this.separator = ".";
        this.len = exp.length;
        this._idx = 0;
        this._cd = exp.charCodeAt(0);
        this._ch = exp[0];
    }
    Tokenizer.literalExp = function (value) {
        return { type: "Literal" /* Literal */, value: value };
    };
    Tokenizer.variableExp = function (name) {
        return { type: "Variable" /* Variable */, name: name };
    };
    Tokenizer.unaryExp = function (operator, target) {
        return { type: "Unary" /* Unary */, target: target, operator: operator };
    };
    Tokenizer.groupExp = function (expressions) {
        return { type: "Group" /* Group */, expressions: expressions };
    };
    Tokenizer.assignExp = function (member, right) {
        return { type: "Assign" /* Assign */, name: member, right: right };
    };
    Tokenizer.objectExp = function (members) {
        return { type: "Object" /* Object */, members: members };
    };
    Tokenizer.arrayExp = function (items) {
        return { type: "Array" /* Array */, items: items };
    };
    Tokenizer.binaryExp = function (operator, left, right) {
        return { type: "Binary" /* Binary */, operator: operator, left: left, right: right };
    };
    Tokenizer.memberExp = function (owner, name) {
        return { type: "Member" /* Member */, owner: owner, name: name };
    };
    Tokenizer.indexerExp = function (owner, key) {
        return { type: "Indexer" /* Indexer */, owner: owner, key: key };
    };
    Tokenizer.funcExp = function (parameters, body) {
        return { type: "Func" /* Func */, parameters: parameters, body: body };
    };
    Tokenizer.callExp = function (callee, args) {
        return { type: "Call" /* Call */, callee: callee, args: args };
    };
    Tokenizer.ternaryExp = function (predicate, whenTrue, whenFalse) {
        return { type: "Ternary" /* Ternary */, predicate: predicate, whenTrue: whenTrue, whenFalse: whenFalse };
    };
    Object.defineProperty(Tokenizer.prototype, "idx", {
        get: function () { return this._idx; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tokenizer.prototype, "cd", {
        get: function () { return this._cd; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tokenizer.prototype, "ch", {
        get: function () { return this._ch; },
        enumerable: false,
        configurable: true
    });
    Tokenizer.prototype.process = function () {
        if (!this.exp) {
            return null;
        }
        var e = this.getExp();
        if (this.idx < this.len) {
            throw new Error("Cannot parse expression, stuck at " + this.idx);
        }
        return e;
    };
    Tokenizer.prototype.getExp = function () {
        this.skip();
        var e = this.tryLiteral()
            || this.tryVariable()
            || this.tryUnary()
            || this.tryGroup()
            || this.tryObject()
            || this.tryArray();
        if (!e) {
            return e;
        }
        e = this.tryKnown(e) || e;
        var r;
        do {
            this.skip();
            r = e;
            e = this.tryMember(e)
                || this.tryIndexer(e)
                || this.tryFunc(e)
                || this.tryCall(e)
                || this.tryTernary(e)
                || this.tryBinary(e);
        } while (e);
        return r;
    };
    Tokenizer.prototype.tryLiteral = function () {
        var that = this;
        function tryNumeric() {
            var n = "";
            function x() {
                while (that.isNumber()) {
                    n += that.ch;
                    that.move();
                }
            }
            x();
            if (that.get(that.separator)) {
                n += that.separator;
                x();
            }
            if (n) {
                if (that.isVariableStart()) {
                    throw new Error("Unexpected character (" + that.ch + ") at index " + that.idx);
                }
                return Tokenizer.literalExp(Number(n));
            }
            return null;
        }
        function tryString() {
            var c = that.ch;
            var inter;
            if (c === "`") {
                inter = true;
            }
            else if (c !== '"' && c !== "'") {
                return null;
            }
            var q = c;
            var es = [];
            var s = "";
            // tslint:disable-next-line:no-conditional-assignment
            while (c = that.move()) {
                if (c === q) {
                    that.move();
                    if (es.length) {
                        if (s) {
                            es.push(Tokenizer.literalExp(s));
                        }
                        return es.reduce(function (p, n) { return Tokenizer.binaryExp("+", p, n); }, Tokenizer.literalExp(""));
                    }
                    return Tokenizer.literalExp(s);
                }
                if (c === "\\") {
                    c = that.move();
                    switch (c) {
                        case "b":
                            s += "\b";
                            break;
                        case "f":
                            s += "\f";
                            break;
                        case "n":
                            s += "\n";
                            break;
                        case "r":
                            s += "\r";
                            break;
                        case "t":
                            s += "\t";
                            break;
                        case "v":
                            s += "\x0B";
                            break;
                        case "0":
                            s += "\0";
                            break;
                        case "\\":
                            s += "\\";
                            break;
                        case "'":
                            s += "'";
                            break;
                        case '"':
                            s += '"';
                            break;
                        default:
                            s += "\\" + c;
                            break;
                    }
                }
                else if (inter && that.get("${")) {
                    if (s) {
                        es.push(Tokenizer.literalExp(s));
                        s = "";
                    }
                    es.push(that.getExp());
                    that.skip();
                    if (that.ch !== "}") {
                        throw new Error("Unterminated template literal at " + that.idx);
                    }
                }
                else {
                    s += c;
                }
            }
            throw new Error("Unclosed quote after " + s);
        }
        return tryNumeric() || tryString();
    };
    Tokenizer.prototype.getVariableName = function () {
        var v = "";
        if (this.isVariableStart()) {
            do {
                v += this.ch;
                this.move();
            } while (this.stillVariable());
        }
        return v;
    };
    Tokenizer.prototype.tryVariable = function () {
        var v = this.getVariableName();
        return v ? Tokenizer.variableExp(v) : null;
    };
    Tokenizer.prototype.tryUnary = function () {
        var _this = this;
        var op = this.settings.unaryOperators.find(function (u) { return _this.get(u); });
        return op ? Tokenizer.unaryExp(op, this.getExp()) : null;
    };
    Tokenizer.prototype.tryGroup = function () {
        return this.get("(") ? Tokenizer.groupExp(this.getGroup()) : null;
    };
    Tokenizer.prototype.getGroup = function () {
        var es = [];
        do {
            var e = this.getExp();
            if (e) {
                es.push(e);
            }
        } while (this.get(","));
        this.to(")");
        return es;
    };
    Tokenizer.prototype.tryObject = function () {
        if (!this.get("{")) {
            return null;
        }
        var es = [];
        do {
            this.skip();
            var ve = this.getExp();
            if (ve.type !== "Variable" /* Variable */ && ve.type !== "Member" /* Member */) {
                throw new Error("Invalid assignment at " + this.idx);
            }
            this.skip();
            if (this.get(":")) {
                if (ve.type !== "Variable" /* Variable */) {
                    throw new Error("Invalid assignment at " + this.idx);
                }
                this.skip();
                es.push(Tokenizer.assignExp(ve.name, this.getExp()));
            }
            else {
                es.push(Tokenizer.assignExp(ve.name, ve));
            }
        } while (this.get(","));
        this.to("}");
        return Tokenizer.objectExp(es);
    };
    Tokenizer.prototype.tryArray = function () {
        if (!this.get("[")) {
            return null;
        }
        var es = [];
        do {
            es.push(this.getExp());
        } while (this.get(","));
        this.to("]");
        return Tokenizer.arrayExp(es);
    };
    Tokenizer.prototype.tryKnown = function (e) {
        if (e.type === "Variable" /* Variable */) {
            var le = e;
            if (this.settings.containsKnown(le.name)) {
                return Tokenizer.literalExp(this.settings.getKnownValue(le.name));
            }
        }
        return null;
    };
    Tokenizer.prototype.tryMember = function (e) {
        if (!this.get(".")) {
            return null;
        }
        this.skip();
        var v = this.getVariableName();
        if (!v) {
            throw new Error("Invalid member identifier at " + this.idx);
        }
        return Tokenizer.memberExp(e, v);
    };
    Tokenizer.prototype.tryIndexer = function (e) {
        if (!this.get("[")) {
            return null;
        }
        this.skip();
        var k = this.getExp();
        if (k == null) {
            throw new Error("Invalid indexer identifier at " + this.idx);
        }
        this.to("]");
        return Tokenizer.indexerExp(e, k);
    };
    Tokenizer.prototype.tryFunc = function (e) {
        if (this.get("=>")) {
            return Tokenizer.funcExp(this.getParameters(e), this.getExp());
        }
        if (e.type === "Variable" /* Variable */ && e.name === "function") {
            var parameters = this.getParameters(this.getExp());
            this.to("{");
            this.skip();
            this.get("return");
            var body = this.getExp();
            this.get(";");
            this.to("}");
            return Tokenizer.funcExp(parameters, body);
        }
        return null;
    };
    Tokenizer.prototype.getParameters = function (e) {
        var _this = this;
        if (e.type === "Group" /* Group */) {
            var ge = e;
            return ge.expressions.map(function (x) {
                if (x.type !== "Variable" /* Variable */) {
                    throw new Error("Invalid parameter at " + _this.idx);
                }
                return x.name;
            });
        }
        if (e.type !== "Variable" /* Variable */) {
            throw new Error("Invalid parameter at " + this.idx);
        }
        return [e.name];
    };
    Tokenizer.prototype.tryCall = function (e) {
        return this.get("(") ? this.getCall(e) : null;
    };
    Tokenizer.prototype.getCall = function (e) {
        var args = this.getGroup();
        return Tokenizer.callExp(e, args);
    };
    Tokenizer.prototype.tryTernary = function (e) {
        if (!this.get("?")) {
            return null;
        }
        var whenTrue = this.getExp();
        this.to(":");
        var whenFalse = this.getExp();
        return Tokenizer.ternaryExp(e, whenTrue, whenFalse);
    };
    Tokenizer.prototype.tryBinary = function (e) {
        var _this = this;
        var op = this.settings.binaryOperators.find(function (b) { return _this.get(b); });
        if (!op) {
            return null;
        }
        var right = this.getExp();
        if (right.type === "Binary" /* Binary */) {
            return this.fixPrecedence(e, op, right);
        }
        return Tokenizer.binaryExp(op, e, right);
    };
    Tokenizer.prototype.isSpace = function () {
        return this.cd === 32 || this.cd === 9 || this.cd === 160 || this.cd === 10 || this.cd === 13;
    };
    Tokenizer.prototype.isNumber = function () {
        return this.cd >= 48 && this.cd <= 57;
    };
    Tokenizer.prototype.isVariableStart = function () {
        return (this.cd === 36) || (this.cd === 95) || // `$`, `_`
            (this.cd >= 65 && this.cd <= 90) || // A...Z
            (this.cd >= 97 && this.cd <= 122); // a...z
    };
    Tokenizer.prototype.stillVariable = function () {
        return this.isVariableStart() || this.isNumber();
    };
    Tokenizer.prototype.move = function (count) {
        if (count === void 0) { count = 1; }
        this._idx += count;
        this._cd = this.exp.charCodeAt(this.idx);
        return this._ch = this.exp.charAt(this.idx);
    };
    Tokenizer.prototype.get = function (s) {
        if (this.eq(this.idx, s)) {
            return !!this.move(s.length);
        }
        return false;
    };
    Tokenizer.prototype.skip = function () {
        // tslint:disable-next-line:curly
        while (this.isSpace() && this.move())
            ;
    };
    Tokenizer.prototype.eq = function (idx, target) {
        return this.exp.substr(idx, target.length) === target;
    };
    Tokenizer.prototype.to = function (c) {
        this.skip();
        if (!this.eq(this.idx, c)) {
            throw new Error("Expected " + c + " at index " + this.idx + ", found " + this.exp[this.idx]);
        }
        this.move(c.length);
    };
    Tokenizer.prototype.fixPrecedence = function (left, leftOp, right) {
        var p1 = this.settings.getBinaryOperator(leftOp).precedence;
        var p2 = this.settings.getBinaryOperator(right.operator).precedence;
        return p2 < p1
            ? Tokenizer.binaryExp(right.operator, Tokenizer.binaryExp(leftOp, left, right.left), right.right)
            : Tokenizer.binaryExp(leftOp, left, right);
    };
    return Tokenizer;
}());
exports.Tokenizer = Tokenizer;
//# sourceMappingURL=Tokenizer.js.map